<template>
  <div data-component="InitializationError">
    <div class="error-container">
      <div class="error-content">
        <div class="error-icon">
          <i class="icon-warning"></i>
        </div>
        
        <h1>Erreur d'initialisation</h1>
        
        <div class="error-message">
          <p>Une erreur s'est produite lors de l'initialisation de l'application.</p>
          <p v-if="errorDetails">{{ errorDetails }}</p>
        </div>
        
        <div class="error-details" v-if="showDetails">
          <h3>Détails techniques :</h3>
          <pre>{{ technicalDetails }}</pre>
        </div>
        
        <div class="error-actions">
          <button @click="retry" class="btn btn-primview" :disabled="retrying">
            <i v-if="retrying" class="icon-spinner spinning"></i>
            {{ retrying ? 'Tentative en cours...' : 'Réessayer' }}
          </button>
          
          <button @click="toggleDetails" class="btn btn-secondary">
            {{ showDetails ? 'Masquer les détails' : 'Afficher les détails' }}
          </button>
          
          <button @click="goToLogin" class="btn btn-outline">
            Retour à la connexion
          </button>
        </div>
        
        <div class="help-section">
          <h3>Que faire ?</h3>
          <ul>
            <li>Vérifiez votre connexion internet</li>
            <li>Actualisez la page (F5)</li>
            <li>Videz le cache de votre navigateur</li>
            <li>Contactez l'administrateur si le problème persiste</li>
          </ul>
        </div>
        
        <div class="contact-info">
          <p>
            <strong>Support technique :</strong>
            <a href="mailto:support@primview.com">support@primview.com</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'InitializationErrorView',
  data() {
    return {
      showDetails: false,
      retrying: false,
      errorDetails: '',
      technicalDetails: ''
    }
  },
  mounted() {
    this.loadErrorDetails()
  },
  methods: {
    ...mapActions('initialLoading', ['initializeApp']),
    
    loadErrorDetails() {
      // Récupérer les détails de l'erreur depuis l'URL ou le store
      const error = this.$route.query.error
      const details = this.$route.query.details
      
      if (error) {
        this.errorDetails = decodeURIComponent(error)
      }
      
      if (details) {
        this.technicalDetails = decodeURIComponent(details)
      } else {
        this.technicalDetails = `
Erreur d'initialisation de l'application
Timestamp: ${new Date().toISOString()}
User Agent: ${navigator.userAgent}
URL: ${window.location.href}
        `.trim()
      }
    },
    
    async retry() {
      this.retrying = true
      
      try {
        // Attendre un peu avant de réessayer
        await new Promise(resolve => setTimeout(resolve, 1000))
        
        // Tenter de réinitialiser l'application
        await this.initializeApp()
        
        // Si succès, rediriger vers l'accueil
        this.$router.push({ name: 'home' })
        
      } catch (error) {
        console.error('Erreur lors de la réinitialisation:', error)
        
        // Mettre à jour les détails de l'erreur
        this.errorDetails = error.message || 'Erreur inconnue'
        this.technicalDetails += `\n\nTentative de réinitialisation échouée: ${error.message}`
        
      } finally {
        this.retrying = false
      }
    },
    
    toggleDetails() {
      this.showDetails = !this.showDetails
    },
    
    goToLogin() {
      // Nettoyer le store et rediriger vers la connexion
      this.$router.push({ name: 'connexion' })
    },
    
    reloadPage() {
      window.location.reload()
    }
  }
}
</script>

<style lang="scss" scoped>
@import './InitializationError.scss';
</style>
